import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-2xl pt-24" data-testid="not-found-page">
      <p className="meta">404</p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold">This page could not be found.</h1>
      <Link to="/" className="mt-8 inline-block font-ui text-sm link-quiet underline underline-offset-4" data-testid="not-found-home-link">Return to the front page</Link>
    </div>
  );
}
